module.exports = __webpack_public_path__ + "static/media/proj2_img3.69cd45f9.jpg";